import PropTypes from 'prop-types';
import React from 'react';
import './AudioPlayer.css';

const AudioPlayer = ({ audioUrl }) => (
    <audio controls className="audio-player">
        <source src={audioUrl} type="audio/mpeg" />
        Your browser does not support the audio element.
    </audio>
);

AudioPlayer.propTypes = {
    audioUrl: PropTypes.string.isRequired,
};

export default AudioPlayer;
